import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import DeliveryTips from './DeliveryTips';
import SectionSubHeader from '../SectionSubHeader/SectionSubHeader';

const DeliveryTipsSection = (props) => (
  <StyledDeliveryTipsSection>
    <SectionSubHeader>Would you like to add a delivery tip?</SectionSubHeader>
    <div className="delivery-tip-title-sub">
      Please note that delivery tip options expire 12 hours after order placement.
    </div>
    <DeliveryTips {...props} />
  </StyledDeliveryTipsSection>
);

const StyledDeliveryTipsSection = styled('div')`
  & .delivery-tip-title-sub {
    color: ${(props) => props.theme.text};
    font-size: 14px;
    font-weight: 400;
    margin: 5px 0 5px;
    padding: 0 0 5px;
  }
`;

DeliveryTipsSection.propTypes = {
  subTotal: PropTypes.number,
  selectedCustomTipValue: PropTypes.number,
  addDeliveryTip: PropTypes.func,
};

DeliveryTipsSection.defaultProps = {
  subTotal: 0,
  selectedCustomTipValue: 0,
  addDeliveryTip: () => {},
};

export default DeliveryTipsSection;
